import { createWebHistory, createRouter } from "vue-router";
import { useAuthStore } from '@/stores/AuthStore.js'
import axios from 'axios'

// styles
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// layouts
import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Admin layout
import Dashboard from "@/views/admin/Dashboard.vue";
import Calendar from "@/views/admin/Calendar.vue";
import Categories from "@/views/admin/Categories.vue";
import Events from "@/views/admin/Events.vue";
import Prayers from "@/views/admin/Prayers.vue";
import Katisashi from "@/views/admin/Katisashi.vue";
import Music from "@/views/admin/Music.vue";
import Evangelio from "@/views/admin/Evangelio.vue";
import Settings from "@/views/admin/Settings.vue";
import Users from "@/views/admin/Users.vue";

// views for Auth layout
import AdminLogin from "@/views/admin/Login.vue";
import Signup from "@/views/admin/Signup.vue";
import AdminForgotPassword from "@/views/admin/ForgotPassword.vue";
import AdminPasswordReset from "@/views/admin/PasswordReset.vue";

// routes
const routes = [
  {
    path: "/admin",
    redirect: "/dashboard",
    component: Admin,
    children: [
      {
        path: "/admin/dashboard",
        name: "Dashboard",
        component: Dashboard,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/calendar",
        name: "Calendar",
        component: Calendar,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/categories",
        name: "Categories",
        component: Categories,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/prayers",
        name: "Prayers",
        component: Prayers,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/katisashi",
        name: "Katisashi",
        component: Katisashi,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/evangelio",
        name: "Evangelio",
        component: Evangelio,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/music",
        name: "Music",
        component: Music,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/events",
        name: "Events",
        component: Events,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/settings",
        name: "Settings",
        component: Settings,
        beforeEnter: [validateCookie]
      },
      {
        path: "/admin/users",
        name: "Users",
        component: Users,
        beforeEnter: [validateCookie]
      }
    ],
  },
  {
    path: "/admin",
    redirect: "/login",
    component: Auth,
    // beforeEnter: [],
    children: [
      {
        path: "/login",
        name: "Login",
        component: AdminLogin,
        // beforeEnter: []
      },
      {
        path: "/signup",
        name: "Signup",
        component: Signup,
        // beforeEnter: []
      },
      {
        path: "/reset-password",
        name: "PasswordReset",
        component: AdminPasswordReset,
        // beforeEnter: []
      },
      {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: AdminForgotPassword,
        // beforeEnter: []
      }
    ],
  },
  { 
    path: "/:pathMatch(.*)*", 
    redirect: "/login" 
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

// router.beforeEach(async (to) => {
//   const authStore = useAuthStore()

//   // make sure the user is authenticated
//   // ❗️ Avoid an infinite redirect
//   if ( !authStore.isAuthenticated && to.name !== 'Login') {
//     return { name: 'Login' } // redirect the user to the login page
//   }
// })

async function validateCookie() {
  const authStore = useAuthStore()
  
  try {
    const { data: response } = await axios.post(`${process.env.VUE_APP_DOMAIN_NAME}/api/admin/validate-cookie`, {}, {
      withCredentials: true
    })

    if (response.isAuth) return response.isAuth

  } catch (error) {
    if (error.response.status === 400 || error.response.status === 401 || error.response.status === 500) {
      authStore.setAuth(false)
      window.localStorage.clear()
      return '/login'
    }
  }
}

export default router
